export default {
  pt: {
    'pedagios.title': 'Pedágios',
    'pedagios.eyebrow': 'Logística',
    'pedagios.aba.indicadores': 'Indicadores',
    'pedagios.aba.passagens': 'Passagens',
    'pedagios.aba.sem-vinculo': 'Sem vínculo',
    'pedagios.filtro.placa': 'Placa',
    'pedagios.filtro.cliente': 'Cliente',
    'pedagios.filtro.contrato': 'Contrato',
    'pedagios.filtro.condicao': 'Condição',
    'pedagios.filtro.divergencia': 'Divergência de eixos',
    'pedagios.filtro.comDivergencia': 'Com qualquer divergência',
    'pedagios.filtro.busca': 'Praça ou concessionária',
    'pedagios.filtro.de': 'De',
    'pedagios.filtro.ate': 'Até',
    'pedagios.filtro.todos': 'Todos',
    'pedagios.filtro.todas': 'Todas',
    'pedagios.filtro.buscar': 'Buscar',
    'pedagios.filtro.limpar': 'Limpar',
    'pedagios.baixarExcel': 'Baixar Excel',
    'pedagios.excelFalhou': 'Não foi possível gerar a planilha.',
    'pedagios.col.passagem': 'Passagem',
    'pedagios.col.placa': 'Placa',
    'pedagios.col.custo': 'Custo',
    'pedagios.col.condicao': 'Condição',
    'pedagios.col.eixos': 'Eixos',
    'pedagios.col.divergencia': 'Divergência',
    'pedagios.col.vinculo': 'Vínculo',
    'pedagios.col.cliente': 'Cliente',
    'pedagios.eixos.cobrados': 'Cobrados',
    'pedagios.eixos.esperados': 'Esperados',
    'pedagios.eixos.fonte.cadastro': 'pelo cadastro de Frota',
    'pedagios.eixos.fonte.edenred': 'pela categoria cadastrada na Edenred',
    'pedagios.vazio': 'Nenhuma passagem no recorte.',
    'pedagios.vazioSemVinculo': 'Toda passagem do recorte tem vínculo.',
    'pedagios.vincular': 'Vincular',
    'pedagios.manual': 'Manual',
    'pedagios.semCalculo': 'Ainda não calculado',
    'pedagios.status.vinculada': 'Vinculada',
    'pedagios.status.ambigua': 'Ambígua',
    'pedagios.status.sem_viagem': 'Sem viagem',
    'pedagios.status.sem_frota': 'Sem frota',
    'pedagios.status.descartada': 'Descartada',
    'pedagios.condicao.vazio': 'Vazio',
    'pedagios.condicao.carregado': 'Carregado',
    'pedagios.condicao.indeterminado': 'Indeterminado',
    'pedagios.condicao.sem_condicao': 'Sem condição',
    'pedagios.perna.escala': 'na escala',
    'pedagios.perna.sem_escala': 'antes da escala',
    'pedagios.perna.transito': 'em trânsito',
    'pedagios.perna.descarga': 'na descarga',
    'pedagios.perna.embarque': 'no embarque da máquina',
    'pedagios.perna.dia': 'pelo dia no Protheus',
    'pedagios.divergencia.acima_do_esperado': 'Eixos impossíveis',
    'pedagios.divergencia.eixo_suspenso': 'Eixo suspenso',
    'pedagios.divergencia.abaixo_carregado': 'Abaixo carregado',
    'pedagios.divergencia.abaixo_a_conferir': 'Abaixo a conferir',
    'pedagios.divergencia.categoria_nao_reconhecida': 'Categoria não reconhecida',
    'pedagios.registro.carga': 'Carga',
    'pedagios.registro.outro_servico': 'Outros Serviços',
    'pedagios.registro.transporte_maquina': 'Transporte Máquina',
    'pedagios.registro.viagem_erp': 'Viagem do Protheus',
    'pedagios.kpi.passagens': 'Passagens',
    'pedagios.kpi.custo': 'Custo',
    'pedagios.kpi.custoHint': 'Soma do valor processado das transações, que é o custo da operação',
    'pedagios.kpi.vazio': 'Custo vazio',
    'pedagios.kpi.carregado': 'Custo carregado',
    'pedagios.kpi.indeterminado': 'Custo indeterminado',
    'pedagios.kpi.aMais': 'Cobrado a mais',
    'pedagios.kpi.aMaisHint': 'Estimativa: o custo por eixo de cada passagem vezes os eixos cobrados acima do esperado',
    'pedagios.kpi.economia': 'Economia eixo suspenso',
    'pedagios.kpi.economiaHint': 'Estimativa: o custo por eixo vezes os eixos não cobrados com o veículo vazio',
    'pedagios.kpi.semVinculo': 'Sem vínculo',
    'pedagios.top.placas': 'Placas com maior custo',
    'pedagios.top.clientes': 'Clientes com maior custo',
    'pedagios.top.divergencias': 'Divergências de eixos',
    'pedagios.top.vazio': 'Nada no recorte.',
    'pedagios.top.passagensN': '{{n}} passagens',
    'pedagios.integracao.desligada': 'A sincronização com a Edenred ainda não está ligada. As passagens aparecem aqui quando ela começar a rodar.',
    'pedagios.integracao.semCredencial': 'A credencial da Edenred ainda não foi configurada.',
    'pedagios.integracao.ultima': 'Última sincronização',
    'pedagios.integracao.erro': 'A última sincronização falhou',
    'pedagios.dialog.titulo': 'Vincular passagem',
    'pedagios.dialog.passagem': 'Passagem',
    'pedagios.dialog.praca': 'Praça',
    'pedagios.dialog.custo': 'Custo',
    'pedagios.dialog.atual': 'Vínculo atual',
    'pedagios.dialog.candidatas': 'Registros do veículo em volta da passagem',
    'pedagios.dialog.cobre': 'Cobre o instante',
    'pedagios.dialog.semCandidatas': 'Nenhum registro do veículo em volta da passagem.',
    'pedagios.dialog.condicao': 'Condição',
    'pedagios.dialog.condicaoAuto': 'Pela etapa do registro',
    'pedagios.dialog.observacao': 'Observação',
    'pedagios.dialog.observacaoObrigatoria': 'Explique o motivo para descartar ou declarar sem viagem.',
    'pedagios.dialog.salvar': 'Vincular ao registro',
    'pedagios.dialog.semViagem': 'Sem viagem',
    'pedagios.dialog.descartar': 'Descartar',
    'pedagios.dialog.automatico': 'Voltar ao automático',
    'pedagios.dialog.salvo': 'Vínculo gravado.',
    'pedagios.dialog.desfeito': 'A passagem voltou ao vínculo automático.',
    'pedagios.viagem.titulo': 'Pedágios',
    'pedagios.viagem.vazio': 'Nenhuma passagem de pedágio ligada a esta viagem.',
    'pedagios.viagem.total': 'Custo total',
    'pedagios.viagem.divergencias': 'Com divergência de eixos',
  },
  en: {
    'pedagios.title': 'Tolls',
    'pedagios.eyebrow': 'Logistics',
    'pedagios.aba.indicadores': 'Indicators',
    'pedagios.aba.passagens': 'Passages',
    'pedagios.aba.sem-vinculo': 'Unlinked',
    'pedagios.filtro.placa': 'Plate',
    'pedagios.filtro.cliente': 'Customer',
    'pedagios.filtro.contrato': 'Contract',
    'pedagios.filtro.condicao': 'Condition',
    'pedagios.filtro.divergencia': 'Axle divergence',
    'pedagios.filtro.comDivergencia': 'Any divergence',
    'pedagios.filtro.busca': 'Plaza or operator',
    'pedagios.filtro.de': 'From',
    'pedagios.filtro.ate': 'To',
    'pedagios.filtro.todos': 'All',
    'pedagios.filtro.todas': 'All',
    'pedagios.filtro.buscar': 'Search',
    'pedagios.filtro.limpar': 'Clear',
    'pedagios.baixarExcel': 'Download Excel',
    'pedagios.excelFalhou': 'The spreadsheet could not be generated.',
    'pedagios.col.passagem': 'Passage',
    'pedagios.col.placa': 'Plate',
    'pedagios.col.custo': 'Cost',
    'pedagios.col.condicao': 'Condition',
    'pedagios.col.eixos': 'Axles',
    'pedagios.col.divergencia': 'Divergence',
    'pedagios.col.vinculo': 'Link',
    'pedagios.col.cliente': 'Customer',
    'pedagios.eixos.cobrados': 'Charged',
    'pedagios.eixos.esperados': 'Expected',
    'pedagios.eixos.fonte.cadastro': 'from the fleet registry',
    'pedagios.eixos.fonte.edenred': 'from the category registered at Edenred',
    'pedagios.vazio': 'No passages in this range.',
    'pedagios.vazioSemVinculo': 'Every passage in this range is linked.',
    'pedagios.vincular': 'Link',
    'pedagios.manual': 'Manual',
    'pedagios.semCalculo': 'Not computed yet',
    'pedagios.status.vinculada': 'Linked',
    'pedagios.status.ambigua': 'Ambiguous',
    'pedagios.status.sem_viagem': 'No trip',
    'pedagios.status.sem_frota': 'No fleet',
    'pedagios.status.descartada': 'Discarded',
    'pedagios.condicao.vazio': 'Empty',
    'pedagios.condicao.carregado': 'Loaded',
    'pedagios.condicao.indeterminado': 'Undetermined',
    'pedagios.condicao.sem_condicao': 'No condition',
    'pedagios.perna.escala': 'while scheduled',
    'pedagios.perna.sem_escala': 'before scheduling',
    'pedagios.perna.transito': 'in transit',
    'pedagios.perna.descarga': 'while unloading',
    'pedagios.perna.embarque': 'while loading the machine',
    'pedagios.perna.dia': 'by the Protheus day',
    'pedagios.divergencia.acima_do_esperado': 'Impossible axles',
    'pedagios.divergencia.eixo_suspenso': 'Lifted axle',
    'pedagios.divergencia.abaixo_carregado': 'Below while loaded',
    'pedagios.divergencia.abaixo_a_conferir': 'Below, to check',
    'pedagios.divergencia.categoria_nao_reconhecida': 'Unknown category',
    'pedagios.registro.carga': 'Load',
    'pedagios.registro.outro_servico': 'Other Services',
    'pedagios.registro.transporte_maquina': 'Machine Transport',
    'pedagios.registro.viagem_erp': 'Protheus trip',
    'pedagios.kpi.passagens': 'Passages',
    'pedagios.kpi.custo': 'Cost',
    'pedagios.kpi.custoHint': 'Sum of the processed amount of each transaction, which is the operating cost',
    'pedagios.kpi.vazio': 'Empty cost',
    'pedagios.kpi.carregado': 'Loaded cost',
    'pedagios.kpi.indeterminado': 'Undetermined cost',
    'pedagios.kpi.aMais': 'Overcharged',
    'pedagios.kpi.aMaisHint': 'Estimate: the cost per axle of each passage times the axles charged above expected',
    'pedagios.kpi.economia': 'Lifted axle savings',
    'pedagios.kpi.economiaHint': 'Estimate: the cost per axle times the axles not charged while empty',
    'pedagios.kpi.semVinculo': 'Unlinked',
    'pedagios.top.placas': 'Plates with the highest cost',
    'pedagios.top.clientes': 'Customers with the highest cost',
    'pedagios.top.divergencias': 'Axle divergences',
    'pedagios.top.vazio': 'Nothing in this range.',
    'pedagios.top.passagensN': '{{n}} passages',
    'pedagios.integracao.desligada': 'The Edenred sync is not on yet. Passages show up here once it starts.',
    'pedagios.integracao.semCredencial': 'The Edenred credential has not been configured yet.',
    'pedagios.integracao.ultima': 'Last sync',
    'pedagios.integracao.erro': 'The last sync failed',
    'pedagios.dialog.titulo': 'Link passage',
    'pedagios.dialog.passagem': 'Passage',
    'pedagios.dialog.praca': 'Plaza',
    'pedagios.dialog.custo': 'Cost',
    'pedagios.dialog.atual': 'Current link',
    'pedagios.dialog.candidatas': 'Vehicle records around the passage',
    'pedagios.dialog.cobre': 'Covers the moment',
    'pedagios.dialog.semCandidatas': 'No vehicle record around the passage.',
    'pedagios.dialog.condicao': 'Condition',
    'pedagios.dialog.condicaoAuto': 'From the record stage',
    'pedagios.dialog.observacao': 'Note',
    'pedagios.dialog.observacaoObrigatoria': 'Explain why to discard or mark without a trip.',
    'pedagios.dialog.salvar': 'Link to record',
    'pedagios.dialog.semViagem': 'No trip',
    'pedagios.dialog.descartar': 'Discard',
    'pedagios.dialog.automatico': 'Back to automatic',
    'pedagios.dialog.salvo': 'Link saved.',
    'pedagios.dialog.desfeito': 'The passage is back to the automatic link.',
    'pedagios.viagem.titulo': 'Tolls',
    'pedagios.viagem.vazio': 'No toll passage linked to this trip.',
    'pedagios.viagem.total': 'Total cost',
    'pedagios.viagem.divergencias': 'With axle divergence',
  },
  es: {
    'pedagios.title': 'Peajes',
    'pedagios.eyebrow': 'Logística',
    'pedagios.aba.indicadores': 'Indicadores',
    'pedagios.aba.passagens': 'Pasajes',
    'pedagios.aba.sem-vinculo': 'Sin vínculo',
    'pedagios.filtro.placa': 'Placa',
    'pedagios.filtro.cliente': 'Cliente',
    'pedagios.filtro.contrato': 'Contrato',
    'pedagios.filtro.condicao': 'Condición',
    'pedagios.filtro.divergencia': 'Divergencia de ejes',
    'pedagios.filtro.comDivergencia': 'Con cualquier divergencia',
    'pedagios.filtro.busca': 'Plaza o concesionaria',
    'pedagios.filtro.de': 'Desde',
    'pedagios.filtro.ate': 'Hasta',
    'pedagios.filtro.todos': 'Todos',
    'pedagios.filtro.todas': 'Todas',
    'pedagios.filtro.buscar': 'Buscar',
    'pedagios.filtro.limpar': 'Limpiar',
    'pedagios.baixarExcel': 'Descargar Excel',
    'pedagios.excelFalhou': 'No fue posible generar la planilla.',
    'pedagios.col.passagem': 'Pasaje',
    'pedagios.col.placa': 'Placa',
    'pedagios.col.custo': 'Costo',
    'pedagios.col.condicao': 'Condición',
    'pedagios.col.eixos': 'Ejes',
    'pedagios.col.divergencia': 'Divergencia',
    'pedagios.col.vinculo': 'Vínculo',
    'pedagios.col.cliente': 'Cliente',
    'pedagios.eixos.cobrados': 'Cobrados',
    'pedagios.eixos.esperados': 'Esperados',
    'pedagios.eixos.fonte.cadastro': 'por el registro de Flota',
    'pedagios.eixos.fonte.edenred': 'por la categoría registrada en Edenred',
    'pedagios.vazio': 'Ningún pasaje en el recorte.',
    'pedagios.vazioSemVinculo': 'Todo pasaje del recorte tiene vínculo.',
    'pedagios.vincular': 'Vincular',
    'pedagios.manual': 'Manual',
    'pedagios.semCalculo': 'Aún no calculado',
    'pedagios.status.vinculada': 'Vinculado',
    'pedagios.status.ambigua': 'Ambiguo',
    'pedagios.status.sem_viagem': 'Sin viaje',
    'pedagios.status.sem_frota': 'Sin flota',
    'pedagios.status.descartada': 'Descartado',
    'pedagios.condicao.vazio': 'Vacío',
    'pedagios.condicao.carregado': 'Cargado',
    'pedagios.condicao.indeterminado': 'Indeterminado',
    'pedagios.condicao.sem_condicao': 'Sin condición',
    'pedagios.perna.escala': 'en la escala',
    'pedagios.perna.sem_escala': 'antes de la escala',
    'pedagios.perna.transito': 'en tránsito',
    'pedagios.perna.descarga': 'en la descarga',
    'pedagios.perna.embarque': 'en el embarque de la máquina',
    'pedagios.perna.dia': 'por el día en Protheus',
    'pedagios.divergencia.acima_do_esperado': 'Ejes imposibles',
    'pedagios.divergencia.eixo_suspenso': 'Eje suspendido',
    'pedagios.divergencia.abaixo_carregado': 'Debajo cargado',
    'pedagios.divergencia.abaixo_a_conferir': 'Debajo a verificar',
    'pedagios.divergencia.categoria_nao_reconhecida': 'Categoría no reconocida',
    'pedagios.registro.carga': 'Carga',
    'pedagios.registro.outro_servico': 'Otros Servicios',
    'pedagios.registro.transporte_maquina': 'Transporte de Máquina',
    'pedagios.registro.viagem_erp': 'Viaje de Protheus',
    'pedagios.kpi.passagens': 'Pasajes',
    'pedagios.kpi.custo': 'Costo',
    'pedagios.kpi.custoHint': 'Suma del valor procesado de las transacciones, que es el costo de la operación',
    'pedagios.kpi.vazio': 'Costo vacío',
    'pedagios.kpi.carregado': 'Costo cargado',
    'pedagios.kpi.indeterminado': 'Costo indeterminado',
    'pedagios.kpi.aMais': 'Cobrado de más',
    'pedagios.kpi.aMaisHint': 'Estimación: el costo por eje de cada pasaje por los ejes cobrados encima de lo esperado',
    'pedagios.kpi.economia': 'Ahorro eje suspendido',
    'pedagios.kpi.economiaHint': 'Estimación: el costo por eje por los ejes no cobrados con el vehículo vacío',
    'pedagios.kpi.semVinculo': 'Sin vínculo',
    'pedagios.top.placas': 'Placas con mayor costo',
    'pedagios.top.clientes': 'Clientes con mayor costo',
    'pedagios.top.divergencias': 'Divergencias de ejes',
    'pedagios.top.vazio': 'Nada en el recorte.',
    'pedagios.top.passagensN': '{{n}} pasajes',
    'pedagios.integracao.desligada': 'La sincronización con Edenred aún no está activa. Los pasajes aparecen aquí cuando empiece.',
    'pedagios.integracao.semCredencial': 'La credencial de Edenred aún no fue configurada.',
    'pedagios.integracao.ultima': 'Última sincronización',
    'pedagios.integracao.erro': 'La última sincronización falló',
    'pedagios.dialog.titulo': 'Vincular pasaje',
    'pedagios.dialog.passagem': 'Pasaje',
    'pedagios.dialog.praca': 'Plaza',
    'pedagios.dialog.custo': 'Costo',
    'pedagios.dialog.atual': 'Vínculo actual',
    'pedagios.dialog.candidatas': 'Registros del vehículo alrededor del pasaje',
    'pedagios.dialog.cobre': 'Cubre el instante',
    'pedagios.dialog.semCandidatas': 'Ningún registro del vehículo alrededor del pasaje.',
    'pedagios.dialog.condicao': 'Condición',
    'pedagios.dialog.condicaoAuto': 'Por la etapa del registro',
    'pedagios.dialog.observacao': 'Observación',
    'pedagios.dialog.observacaoObrigatoria': 'Explique el motivo para descartar o declarar sin viaje.',
    'pedagios.dialog.salvar': 'Vincular al registro',
    'pedagios.dialog.semViagem': 'Sin viaje',
    'pedagios.dialog.descartar': 'Descartar',
    'pedagios.dialog.automatico': 'Volver al automático',
    'pedagios.dialog.salvo': 'Vínculo guardado.',
    'pedagios.dialog.desfeito': 'El pasaje volvió al vínculo automático.',
    'pedagios.viagem.titulo': 'Peajes',
    'pedagios.viagem.vazio': 'Ningún pasaje de peaje vinculado a este viaje.',
    'pedagios.viagem.total': 'Costo total',
    'pedagios.viagem.divergencias': 'Con divergencia de ejes',
  },
}
